import { Button, Form, Select } from 'antd';
import { NotificationFilterFormValueslist } from 'features/notification/components/type';
import { useSendNotification } from 'features/notification/use-cases/send-notification';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const SendNotificationModal = ({ onClose, EditData }: { onClose: () => void; showModal: boolean, refetch: () => void, EditData: any }) => {

    const formName = 'add-shop-coupon-form';
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<NotificationFilterFormValueslist>();
    const { isLoading, mutate } = useSendNotification();
    // const { data, isFetching } = useGetType('' as any, { retry: false });

    const handleClose = () => {
        onClose();
        form.resetFields();
    }

    const getInitialValues = {
        user_type: undefined,
        message: undefined,
        device: undefined,
    };

    const { t } = useTranslation();

    const handleUpdate = (formData: any) => {

        formData.type = EditData?.title;
        formData.message = EditData?.content;
        mutate(formData, { onSuccess: hanldeSuccess });
    };

    const hanldeSuccess = () => {
        handleClose();
        // refetch();
    }

    useEffect(() => {
        if (EditData) {
            form.setFieldsValue(EditData)
        } else {
            form.resetFields()
        }
    }, [EditData])

    const UserType = [
        { value: "Android", label: 'Android' },
        { value: "IOS", label: 'IOS' },
        { value: "Both", label: 'Both' },
    ];

    return (
        <>
            <div className='popup'>
                <div className='modal_head'>
                    <h4>Send Notification</h4>
                    <button onClick={handleClose} className='close-btn'>
                        &times;
                    </button>
                </div>
                <div className='modal_body' >
                    <Form
                        id={formName}
                        name={formName}
                        form={form}
                        layout='vertical'
                        initialValues={getInitialValues}
                        onFinish={handleUpdate}
                        // requiredMark={'optional'}
                        onFinishFailed={() => {
                            setValidateTrigger(['onChange']);
                        }}
                        validateTrigger={validateTrigger}
                        disabled={isLoading}
                    >
                        <FormSectionsSeparator title={""}>
                            <Form.Item
                                label="User Type"
                                name={"device"}
                                rules={[
                                    {
                                        required: true,
                                        message: t('validateMessages.custom.nomsg'),
                                    },
                                ]}
                            // defaultvalue={""}
                            >
                                <Select
                                    placeholder="Please select User Type"
                                    style={{ width: "100%" }}
                                    options={UserType}
                                />
                            </Form.Item>
                            <Form.Item>
                                <div className='form-button'>
                                    <Button htmlType='submit' className='btn' type='primary'>Save</Button>
                                </div>
                            </Form.Item>
                        </FormSectionsSeparator>

                    </Form>
                </div>
            </div >
        </>
    )
};

